// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Qr4h","list":"PatternAutocomplete_list__3dCT_"};